// extracted by mini-css-extract-plugin
module.exports = {"container":"tag_container__1vJ3g","small":"tag_small__xmsCY"};